/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ServerClientAssociation,
  ServerClientAssociation$inboundSchema,
} from "./serverclientassociation.js";

export type ListServerClientAssociationsResult = {
  /**
   * The server's associated upstream OAuth clients, oldest first.
   */
  associations: Array<ServerClientAssociation>;
};

/** @internal */
export const ListServerClientAssociationsResult$inboundSchema: z.ZodMiniType<
  ListServerClientAssociationsResult,
  unknown
> = z.object({
  associations: z.array(ServerClientAssociation$inboundSchema),
});

export function listServerClientAssociationsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListServerClientAssociationsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListServerClientAssociationsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListServerClientAssociationsResult' from JSON`,
  );
}
